import React from "react";

import { styled } from "@mui/system";
import { MenuItem, Select } from "@mui/material";

const StyledContainer = styled("div")(() => ({
  margin: "8px 0px",
  width: "100%",
  maxWidth: "16rem",
}));
const StyledSelect = styled(Select)(() => ({
  display: "flex",
  backgroundColor: "white",
  width: "100%",
}));

const SingleSelect = (props) => {
  const {
    id,
    name,
    value,
    label,
    placeholder,
    handleChange,
    menuItems,
    defaultSelected,
    onBlur,
    disabled
  } = props;
  const selectProps = {
    id,
    name,
    value,
    label,
  };
  return (
    <StyledContainer>
      <StyledSelect
        {...selectProps}
        multiline
        defaultValue={defaultSelected}
        displayEmpty
        renderValue={(selected) => {
          return selected.label || placeholder;
        }}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
      >
        <MenuItem value={{}}>
          <em>None</em>
        </MenuItem>
        {menuItems.map((menuItem) => (
          <MenuItem key={menuItem.id} value={menuItem}>
            {menuItem.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledContainer>
  );
};

export default SingleSelect;
